export const langPath = (path: string) => {
  const pathLng = window.location.hash.split('/')[1];
  if (pathLng) {
    return `/${pathLng}${path}`;
  } else {
    return `/en${path}`;
  }
};
